import { gql } from '@generated/gql';

const cashbackReviewsQuery = gql(`
  query CashbackReviews {
    cashbackReviews {
      reviewer
      text
      platform
    }
  }
`);

const cashbackRetailersQuery = gql(`
  query CashbackRetailers {
    cashbackRetailers {
      id
      name
      logoUrl
      discount
    }
  }
`);

const selectCbcQuoteMutation = gql(`
  mutation SelectCbcQuote($input: SelectQuoteInput!) {
    selectQuote(input: $input) {
      id
      monthlyCost {
        value
      }
      quotes {
        id
        discounts {
          credit {
            ... on AmountCredit {
              amount
            }
            ... on PercentageCredit {
              percentage
            }
          }
          description
          id
          qualified
          qualificationMessage
          creditAppliesAfter
          creditFrequency
        }
        totalMonthlyCost {
          value
        }
        selected
        product {
          id
          name
          type
        }
      }
    }
  }
`);

export { selectCbcQuoteMutation, cashbackReviewsQuery, cashbackRetailersQuery };
